import script from "./ClassificationTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationTreeNode.vue?vue&type=style&index=0&id=53c1c35d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c1c35d"]])

export default __exports__